// =============================================================================
// Document Notification Repository - lecture/compteurs/actions des notifications docs
// =============================================================================

import { supabase } from '@/integrations/supabase/client';

export interface DocNotification {
  id: string;
  orgId: string;
  documentId: string;
  pageId: string;
  documentTitle: string | null;
  senderName: string | null;
  messagePreview: string | null;
  type: string;
  isRead: boolean;
  createdAt: string;
}

function mapRow(row: any): DocNotification {
  return {
    id: row.id,
    orgId: row.org_id,
    documentId: row.document_id,
    pageId: row.page_id,
    documentTitle: row.document_title,
    senderName: row.sender_name,
    messagePreview: row.message_preview,
    type: row.type || 'doc_mention',
    isRead: row.is_read,
    createdAt: row.created_at,
  };
}

export async function fetchDocNotifications(orgId: string, limit = 30): Promise<DocNotification[]> {
  const { data, error } = await supabase
    .from('docs_notifications')
    .select('*')
    .eq('org_id', orgId)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    console.error('Error fetching doc notifications:', error);
    return [];
  }

  return (data || []).map(mapRow);
}

export async function countUnreadDocNotifications(orgId: string): Promise<number> {
  const { count, error } = await supabase
    .from('docs_notifications')
    .select('*', { count: 'exact', head: true })
    .eq('org_id', orgId)
    .eq('is_read', false);

  if (error) {
    console.error('Error counting doc notifications:', error);
    return 0;
  }

  return count || 0;
}

export async function markDocNotificationRead(id: string): Promise<boolean> {
  const { error } = await supabase
    .from('docs_notifications')
    .update({ is_read: true })
    .eq('id', id);

  return !error;
}

export async function markAllDocNotificationsRead(orgId: string): Promise<boolean> {
  const { error } = await supabase
    .from('docs_notifications')
    .update({ is_read: true })
    .eq('org_id', orgId)
    .eq('is_read', false);

  return !error;
}

export async function deleteDocNotification(id: string): Promise<boolean> {
  const { error } = await supabase
    .from('docs_notifications')
    .delete()
    .eq('id', id);

  return !error;
}